import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseInput = ({ theme, error }) => css`
  margin: ${theme.spacings.byte} 0;

  width: 100%;
  padding: ${theme.spacings.byte} 20px;

  font-size: ${theme.typography.text.kilo.fontSize};
  font-family: ${theme.font.family.default};

  color: ${theme.colors.n600};

  border: 1px solid ${error ? theme.colors.success : theme.colors.n100};

  outline: transparent;
  border-radius: 30px;
  appearance: none;

  transition: all 300ms ease-in;

  &:disabled {
    background: ${theme.colors.n100};
  }
`

export const TextInput = styled('input')(baseInput)
export const SelectInput = styled('select')(baseInput)
